import Vue from 'vue'
import router from './router'
import VueRouter from 'vue-router'
import App from './App.vue'
// import VueAwesomeSwiper from 'vue-awesome-swiper'

Vue.config.productionTip = false
Vue.use(VueRouter)
// Vue.use(VueAwesomeSwiper)
// import 'swiper/dist/css/swiper.css'
// import '@/styles/index.scss'
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
